import { z } from 'zod';
import { idSchema, isoDateSchema } from '../primitives/branded.js';
import { priceSchema, volumeSchema } from '../primitives/numeric.js';
/**
 * One daily OHLCV candle. `date` is a trading day, never a timestamp, which keeps
 * the natural key (`instrumentId`, `date`) free of timezone ambiguity.
 */
export const dailyBarSchema = z
    .object({
    date: isoDateSchema,
    open: priceSchema,
    high: priceSchema,
    low: priceSchema,
    close: priceSchema,
    volume: volumeSchema,
})
    .refine((bar) => bar.high >= bar.low, { message: 'high muss >= low sein', path: ['high'] });
/** Bars as returned for a chart, together with the instrument they belong to. */
export const barSeriesSchema = z.object({
    instrumentId: idSchema,
    symbol: z.string(),
    bars: z.array(dailyBarSchema),
    /** First and last stored trading day, independent of the requested window. */
    coverageStart: isoDateSchema.nullable(),
    coverageEnd: isoDateSchema.nullable(),
});
/** Query parameters for the bars endpoint. */
export const barQuerySchema = z.object({
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
    /** Hard cap so a chart request can never pull an unbounded result set. */
    limit: z.coerce.number().int().min(1).max(20000).default(5000),
});
//# sourceMappingURL=bar.js.map